import { registerPlugin } from '@capacitor/core';
import type { ParentHubStripePlugin } from './definitions';

const ParentHubStripe = registerPlugin<ParentHubStripePlugin>('ParentHubStripe');

export * from './definitions';
export { ParentHubStripe };
